<template>
    <section>
        <navigation></navigation>
        <h5 class="center-align">Customers</h5>
        <!-- Dropdown Trigger -->
          <!-- Dropdown Trigger -->
       
        <div class="row">
            <div class="input-field" style="margin:0 100px 0 100px;" v-if="isAdmin">
                <!-- <select v-model="selected">
                <option v-for="option in options" :key="option.text" :value="option.value">
                    {{ option.text }}
                </option>
                </select>
                <span>Selected: {{ selected }}</span> -->

                 <select id="myDropdown" v-model="cat">
                    <option value="" disabled selected>Choose merchant</option>
                    <option v-for="merchant in merchantDocs" :key="merchant.id" :value="merchant.id" @click="postData(merchant.id)">{{merchant.companyName}}</option>
                </select>
                <!-- <span>Selected: {{ cat }}</span> -->
                <!-- <select v-model="cat" v-for="merchant in merchantDocs" :key="merchant.id">
                    <option value="" disabled selected>Please Choose Merchant</option>
                    <option :value="merchant.id">{{merchant.fullName}}</option>
                </select> -->
                <!-- <label>Header Type</label> -->
            </div>
             <!-- <div class="input-field" style="margin:0 100px 0 100px;" v-if="isAdmin">
                <input id="filter_user_field" type="text" class="validate" v-model="search">
                <label for="filter_user_field">Search by name</label>
             </div> -->
            <div class="input-field" style="margin:0 100px 0 100px;">
                <input id="filter_user_field" type="text" class="validate" v-model="search">
                <label for="filter_user_field">Search by name</label>
            </div>
            <ul class="pagination">
                <li class="page-item">
                    <button type="button" class="page-link" v-if="page != 1" @click="page--"> Previous </button>
                </li>
                <li class="page-item">
                    <button type="button" class="page-link" v-for="pageNumber in pages.slice(page-1, page+5)" @click="page = pageNumber" v-bind:key="pageNumber"> {{pageNumber}} </button>
                </li>
                <li class="page-item">
                    <button type="button" @click="page++" v-if="page < pages.length" class="page-link"> Next </button>
                </li>
            </ul>	
        </div>
        

        <div class="row">
            <div class="col s12">
                <table>
                    <thead>
                        <tr>
                            <th>No.</th>
                            <th>Name</th>
                            <th>Date and Time Entered</th>
                            <th>Temperature</th>
                            <th>No Signs and Symptoms of possible COVID 19</th>
                            <th>Followed Quarantine Protocol</th>
                            <th>No known exposure in the community</th>
                            <th>No known travel to high COVID 19 areas</th>
                            <th>Negative IgM</th>
                            <th>Negative IgG</th>
                            <th>Fit to travel</th>
                            <th>Fit to work</th>
                        </tr>
                    </thead>
                    <tbody id="listOfLogs" v-for="patient in displayedPosts" :key="patient.id">
                        <tr :id="patient.number" :ref="patient.number" :style="[patient.temperature > 37 || !patient.noSigns ? patient.temperature > 37 && !patient.noSigns ? {'background-color': '#d50000','color':'white'} : {'background-color': '#FF6D00','color':'white'} : {'background-color': '#00C853','color':'white' }]">
                            <td>{{patient.number}}</td>
                            <td>{{patient.name}}</td>
                            <td>{{patient.timestamp}}</td>
                            <td>{{patient.temperature}}</td>
                            <td>{{convertBooleanToWord(patient.noSigns)}}</td>
                            <td>{{convertBooleanToWord(patient.followed)}}</td>
                            <td>{{convertBooleanToWord(patient.noKnownExposure)}}</td>
                            <td>{{convertBooleanToWord(patient.noKnownTravel)}}</td>
                            <td>{{convertBooleanToWord(patient.negativeIgM)}}</td>
                            <td>{{convertBooleanToWord(patient.negativeIgG)}}</td>
                            <td>{{convertBooleanToWord(patient.fitTravel)}}</td>
                            <td>{{convertBooleanToWord(patient.fitWork)}}</td>
                        </tr>
                    </tbody>

                </table>
            </div>
        </div>
    </section>
</template>

<script>
import navigation from "@/components/NavBar.vue";
import firebase from "firebase";
import SimpleDateFormat from "@riversun/simple-date-format";

export default {
    data() {
        return {
            search: '',
            cat: "",
            merchantDocs:[],
            patients:[],
            patientsSorted:[],
            todos: [],
            todo: {
                title: ""
            },
            selected: 'A',
            options: [
                { text: 'One', value: 'A' },
                { text: 'Two', value: 'B' },
                { text: 'Three', value: 'C' }
            ],
            value: 'https://example.com',
            size: 300,
            unconvertedText: "",
            isAdmin: false,
            page: 1,
			perPage: 10,
			pages: [],	
        };
    },
    computed: {
        filteredItems() {
            return this.patientsSorted.filter(todo => {
                return (todo.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1)
            })
        },
        displayedPosts () {
			return this.paginate(this.patientsSorted);
		}
    },
    mounted(){
         $('.dropdown-trigger').dropdown();
         $(document).ready(function(){
            $('select').formSelect();
        });
    },
    created() {
        
        const vm = this;
       
        firebase.auth().onAuthStateChanged(user => {
            if (user) {
                const vm = this;
                this.user = user;
                const cityRef = firebase.firestore().collection('merchants').doc(user.uid);
                cityRef.get().then(function(doc) {
                    if (doc.exists) {
                        if(doc.data().type === "admin"){
                            vm.getMerchant();
                            vm.isAdmin = true;
                        }
                        else{
                            vm.isAdmin = false;
                            vm.postData(user.uid);
                            vm.getSpecificPatientsByMerchant(user.uid);
                        }
                    } 
                }).catch(function(error) {
                    console.log("Error getting document:", error);
                });
            }
            else{
                $router.push({name:'Home'})
            }
        });
    },
    components: { navigation },
    methods: {
        setPages () {
			let numberOfPages = Math.ceil(this.patientsSorted.length / this.perPage);
			for (let index = 1; index <= numberOfPages; index++) {
				this.pages.push(index);
            }
            // this.paginate(this.patientsSorted);
		},
		paginate (posts) {
			let page = this.page;
			let perPage = this.perPage;
			let from = (page * perPage) - perPage;
			let to = (page * perPage);
			return  this.patientsSorted.slice(from, to);},
        convertStringToQRCode(){
            console.log("yess");
            this.value = unconvertedText;
            unconvertedText = "";
        },
        convertBooleanToWord(str){
            if(str){
                return "Yes";
            }
            else{
                return "No";
            }
        },
        highlightPatient(patient){
            
            if((patient.temperature < 37 && patient.noSigns)){
                return "{'background-color' : '#00C853'}"
            }
            else{
                if(patient.temperature >= 37 && !patient.noSigns){
                    return "{'background-color' : '#d50000'}"
                }
                else{
                    return "{'background-color' : '#FF6D00'}"
                }
            }

        },
        async getSpecificPatientsByMerchant(str){
            var mine = this;
             var num = 1;
            console.log("gotoo");
             console.log(str);
            this.patients = [];
            this.patientsSorted = [];
            var customerRef = await firebase
                .firestore()
                .collection("Customers")
                .where("merchantID","==",str)
                .get();
                for(const doc of customerRef.docs){
                    console.log(doc.id, " => ", doc.data());
                    this.merchantDocs.push(doc.data());
                    var timestamp = doc.data().timeStamp;
                        var date = new Date(timestamp);

                        var year = date.getFullYear();
                        var month = date.getMonth() + 1;
                        var day = date.getDate();
                        var hours = date.getHours();
                        var minutes = date.getMinutes();
                        var seconds = date.getSeconds();

                        // var patientsKo = {
                        //     number: num,
                        //     id: doc2.id,
                        //     name: doc.data().name,
                        //     timestamp: year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds
                        // };
                        var patientsKo = {
                            number: num,
                            id: doc.data().patientID,
                            timestamp: doc.data().timeStampEntered,
                            temperature: doc.data().temperature,
                            noSigns: doc.data().noSigns,
                            followed: doc.data().followed,
                            noKnownExposure: doc.data().noKnownExposure,
                            noKnownTravel: doc.data().noKnownTravel,
                            negativeIgM: doc.data().negativeIgM,
                            negativeIgG: doc.data().negativeIgG,
                            fitTravel: doc.data().fitTravel,
                            fitWork: doc.data().fitWork,
                            };
                        this.patients.push(patientsKo);
                        num = num + 1;
                    // var $newOpt = $("<option>").attr("value",doc.id).text(doc.data().fullName)
                    // $("#myDropdown").append($newOpt)

                    // // fire custom event anytime you've updated select
                    // $("#myDropdown").trigger('contentChanged')
               }

               this.patients.sort(function(a,b){
            // Turn your strings into dates, and then subtract them
            // to get a value that is either negative, positive, or zero.
                return new Date(b.timestamp) - new Date(a.timestamp);
                });
                 console.log(this.patients[0].id);
                 console.log(this.patients.length);
                for(var i = 0; i<this.patients.length; i++){
                    console.log("gotoo2");
                    console.log(this.patients[i].id);
                        var patientInfo = await firebase
                            .firestore()
                            .collection("Users")
                            .doc(this.patients[i].id)
                            .get()
                            .then(doc =>{
                                if(doc.exists){
                                    console.log("meron");

                                    const sdf = new SimpleDateFormat("MMM dd, yyyy hh:mm a");

                            
                                    var patientsKoLast = {
                                        number: i + 1,
                                        id: doc.id,
                                        name: doc.data().name,
                                        timestamp: sdf.format(new Date(this.patients[i].timestamp)),
                                        temperature: this.patients[i].temperature,
                                        noSigns: this.patients[i].noSigns,
                                        followed: this.patients[i].followed,
                                        noKnownExposure: this.patients[i].noKnownExposure,
                                        noKnownTravel: this.patients[i].noKnownTravel,
                                        negativeIgM: this.patients[i].negativeIgM,
                                        negativeIgG: this.patients[i].negativeIgG,
                                        fitTravel: this.patients[i].fitTravel,
                                        fitWork: this.patients[i].fitWork,
                                    };

                                     this.patients[i].number = i + 1;
                                     this.patientsSorted.push(patientsKoLast);
                                     console.log(document.getElementById("1"));
                                     console.log("ditodito");
                                
                                     
                                    // console.log(document.getElementById(patientsKoLast.number).id);
                                }
                                else{
                                    console.log("wala");    
                                }
                            });

                           
                        
                        

                        
                        
                }
                this.setPages();
                //this.patientsSorted = this.patients;
        },
        postData(str){
            console.log(str);
        },
        async getMerchant(){
            var merchantRef = await firebase
                .firestore()
                .collection("merchants")
                .get();
                for(const doc of merchantRef.docs){
                    console.log(doc.id, " => ", doc.data());
                    this.merchantDocs.push(doc.data());
                    // var $newOpt = $("<option>").attr("value",doc.id).text(doc.data().fullName)
                    // $("#myDropdown").append($newOpt)

                    // // fire custom event anytime you've updated select
                    // $("#myDropdown").trigger('contentChanged')
               }

               console.log(this.merchantDocs);
               console.log(this.options);
                this.$nextTick(() => {
                this.$M.FormSelect.init(
                    document.querySelectorAll("select"),
                    {}
                );
            });
        },
        async getTodos() {
            var todosRef = await firebase
                .firestore()
                .collection("users")
                .doc(firebase.auth().currentUser.uid)
                .collection("todos");
            todosRef.onSnapshot(snap => {
                this.todos = [];
                snap.forEach(doc => {
                    var todo = doc.data();
                    todo.id = doc.id;
                    this.todos.push(todo);
                });
            });
        },
        async getPatients() {
            var num = 1;
            var patientsRef = await firebase
                .firestore()
                .collection("Users")
                .where("type","==","patient")
                .get();

            for(const doc of patientsRef.docs){
                console.log(doc.id, " => ", doc.data());
                var patientRef2 = await doc.ref.collection("Covid19Form")
                            .orderBy("timeStamp", "desc")
                            .limit(1)
                            .get();
                  for(const doc2 of patientRef2.docs){
                        var timestamp = doc2.data().timeStamp;
                        var date = new Date(timestamp);

                        var year = date.getFullYear();
                        var month = date.getMonth() + 1;
                        var day = date.getDate();
                        var hours = date.getHours();
                        var minutes = date.getMinutes();
                        var seconds = date.getSeconds();

                        // var patientsKo = {
                        //     number: num,
                        //     id: doc2.id,
                        //     name: doc.data().name,
                        //     timestamp: year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds
                        // };
                        var patientsKo = {
                            number: num,
                            id: doc2.id,
                            name: doc.data().name,
                            timestamp: doc2.data().timeStamp
                            };
                        this.patients.push(patientsKo);
                        num = num + 1;
                  }          
            }

            this.patients.sort(function(a,b){
            // Turn your strings into dates, and then subtract them
            // to get a value that is either negative, positive, or zero.
                return new Date(b.timestamp) - new Date(a.timestamp);
            });
            for(var i = 0; i<this.patients.size; i++){

                    var patientsKoLast = {
                            number: i + 1,
                            id: doc2.id,
                            name: doc.data().name,
                            timestamp: doc2.data().timeStamp
                            };

                this.patients[i].number = i + 1;
            }
            this.patientsSorted = this.patients;


        },
        updateTodoItem(docId, e) {
            var isChecked = e.target.checked;
            firebase
                .firestore()
                .collection("users")
                .doc(firebase.auth().currentUser.uid)
                .collection("todos")
                .doc(docId)
                .update({
                    isCompleted: isChecked
                });
        },
        deleteToDo(docId) {
            firebase
                .firestore()
                .collection("users")
                .doc(firebase.auth().currentUser.uid)
                .collection("todos")
                .doc(docId)
                .delete();
        }
    },
     watch: {
        cat: function(newValue, oldValue) {
         console.log(newValue, oldValue);
         this.getSpecificPatientsByMerchant(newValue);
        }
    },
};
</script>

<style>
.fade {
    opacity: 0.4 !important;
}
li {
    font-size: 1.3em;
}
.collection.with-header {
    max-width: 500px;
    margin: 0 auto;
}
.deleteIcon {
    margin-right: 10px;
    cursor: pointer;
}
.deleteIcon:hover {
    opacity: 0.5;
}
button.page-link {
     padding: 10px;
    text-align: right;
	display: inline-block;
}
button.page-link {
    font-size: 20px;
    color: #29b3ed;
    font-weight: 500;
}
.pagination {
     text-align: right;
     margin-right: 10px;
}
</style>

